import 'src/polyfills-legacy';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
